{
  "manager": {
    "globalSearchResults": {
      "searching": "Searching...",
      "unavailable": "Search is temporarily unavailable.",
      "noResults": "No results found for \"{query}\""
    }
  }
}
